export class ExpenseFilter{
    expenseDateFrom: string = null;//date string
    expenseDateTo: string = null;
    expenseType: string;
    orNumber: string;
    isVatable: boolean;
    supportingData: number;

    constructor() {
        this.expenseDateFrom = null;
        this.expenseDateTo = null;
    }
}


// WEBPACK FOOTER //
// ./src/app/models/expenses/expenseFilter.ts